//
// default environment variables for our sdk
//

const defaultEnv = {
}

export default defaultEnv
